import React from "react";
import {
  Box,
  makeStyles,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";

const CardEndArea = (props: any) => {
  return <>{props?.children}</>;
};

export const BannerCard = (props: any) => {
  const classes = useStyles();
  const { data } = props;
  const CardImage = props.cardImage;
  return (
    <Box onClick={() => props.onClick(data)} className={classes.container}>
      <Container className={classes.root}>
        <Grid container xs={4}>
          <CardImage />
        </Grid>
        <Grid container xs={4} justifyContent="center">
          <Grid item container>
            <Typography variant="h6" component="span" color="textPrimary">
              {data?.topText ?? ""}
            </Typography>
          </Grid>
          <Grid item container className={classes.gridMargin}>
            <Typography variant="body2" component="span" color="textSecondary">
              {data?.smallText ?? data?.bottomText ?? ""}
            </Typography>
          </Grid>
        </Grid>
        <Grid container xs={4} className={classes.arrowArea}>
          {props?.children}
        </Grid>
      </Container>
    </Box>
  );
};
const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: "24px",
  },
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 24px",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    boxSizing: "border-box",
    borderRadius: "20px",
    "&:hover": {
      background: "rgba(158, 0, 93, 0.04)",
      transition: "all 200ms ease",
    },
  },
  gridMargin: {
    marginTop: "5px",
  },
  arrowArea: {
    textAlign: "right",
  },
}));
BannerCard.EndArea = CardEndArea;
